import React, { useCallback } from 'react';
import { route } from '../../../../../services/utils';
import {
  LIVESTOCK_ANIMALS_AND_EVENTS_INDEX,
  LIVESTOCK_ANIMALS_PREGNANCY_CHECK_EDIT,
} from '../../../../../router/routes';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Form from '../../../../../components/form';
import Table from '../../../../../components/common/table/table';
import useFormBody from './use-form-body';
import { useShowFooter } from '../use-show-footer';
import { useFormDestroy } from '../use-form-destroy';
import { usePregnancyCheckState } from './use-pregnancy-state';
import { AnimalEventAnimal } from '../../../../../interfaces/animal-event';
import TableVerticalSizeFixer from '../../../../../components/common/table/table-vertical-size-fixer/table-vertical-size-fixer';
import AnimalsAndEventsTabsKeys from '../../enums/animals-and-events-tab-keys';
import animalEventFormCss from '../animal-events-form.module.css';
import { useQuery } from '../../../../../hooks/use-query';
import AnimalExportButton from '../animal-export-button';

export default function ShowPregnancy() {
  const { farmId } = useParams<{
    farmId: string;
  }>();
  const { t } = useTranslation();

  const transKeyPrefix = 'pages.livestock.animals_and_events.';
  const tp = useCallback(
    (key: string, params?: { [key: string]: string | number }) =>
      t(transKeyPrefix.concat(key), params),
    [t]
  );

  const [otherState, animals] = usePregnancyCheckState();
  const body = useFormBody();
  const submit = useFormDestroy();
  const [queries] = useQuery();
  const footer = useShowFooter(
    `${LIVESTOCK_ANIMALS_PREGNANCY_CHECK_EDIT}${
      queries.to ? '?to='.concat(queries.to) : ''
    }`
  );

  return (
    <Form
      backTo={route(LIVESTOCK_ANIMALS_AND_EVENTS_INDEX, {
        tab:
          queries.to === 'events'
            ? AnimalsAndEventsTabsKeys.events
            : AnimalsAndEventsTabsKeys.animals,
        farmId,
      })}
      top={[]}
      title={tp('animals.types.pregnancy')}
      body={body}
      footer={footer}
      mode={'view'}
      submit={submit}
      values={otherState}
      noticeAccessor="ViewForm"
      className={animalEventFormCss['animal_event_form']}
      confirmation={{
        title: t('delete'),
        content: <p>{tp('events.grazing.delete_warning')}</p>,
        buttons: [
          { title: t('yes'), name: 'yes', value: true },
          { title: t('no'), name: 'no', value: false },
        ],
      }}
    >
      <AnimalExportButton animals={animals} />
      <TableVerticalSizeFixer>
        <Table<AnimalEventAnimal>
          data={animals}
          filteredTotalsParams={{
            recordName: 'pages.livestock.animals_and_events.events.table_title',
            fullText: { tp, key: 'events.table_title' },
          }}
          paginate={false}
          keyAccessor="id"
          columns={[
            {
              accessor: 'animal_id',
              header: tp('events.grazing.id'),
              sortable: false,
              className: 'animal_id',
            },
            {
              accessor: 'name',
              header: tp('events.grazing.name'),
              sortable: false,
              className: 'name',
            },
            {
              accessor: 'insemination',
              header: tp('events.insemination'),
              sortable: false,
              className: 'name',
            },
          ]}
        />
      </TableVerticalSizeFixer>
    </Form>
  );
}
